import React from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';

interface IShowRejectedToggleProps {
  label?: string;
  checked: boolean;
  count: number;
  onChange: (checked: boolean) => void;
}

export const ShowRejectedToggle: React.FC<IShowRejectedToggleProps> = ({
  label = 'Show rejected',
  checked,
  count,
  onChange,
}) => (
  <FormControlLabel
    control={
      <Switch
        checked={checked}
        color="primary"
        onChange={(event) => onChange(event.target.checked)}
        sx={(theme) => ({
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: theme.palette.common.white,
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: theme.palette.text.link,
            opacity: 1,
          },
          '& .MuiSwitch-thumb': {
            backgroundColor: theme.palette.common.white,
          },
        })}
      />
    }
    label={
      <Box display="flex" alignItems="center" gap={0.75}>
        <Box component="span">{label}</Box>
        <Box
          component="span"
          minWidth={12}
          textAlign="left"
          color="text.lightGrey"
          sx={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {count > 0 ? count : ' '}
        </Box>
      </Box>
    }
  />
);
